'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCssLayouts = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _proGalleryLayouter = require('pro-gallery-layouter');

var _cssScrollHelper = require('../helpers/cssScrollHelper.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const CDN_URL = 'https://static.wixstatic.com/media/';
var desktopWidths = [480, 768, 1024, 1280, 1440, 1680, 1920, 2560];
var mobileWidths = [320]; //, 375, 414, 480, 600, 768, 900]; (mobile is currently fixed to 320px)

var getImageStyle = function getImageStyle(item) {
  return {
    top: item.offset.top,
    left: item.offset.left,
    width: item.width,
    height: item.height
    // backgroundImage: `url(${getImageSrc(item)})`
  };
};

var createCssFromLayouts = function createCssFromLayouts(layouts, styleParams, widths) {

  var cssStrs = [];
  layouts.forEach(function (layout, idx) {
    var cssStr = '';
    if (layout) {
      var width = widths[idx];
      var lastWidth = widths[idx - 1];
      var isFirstMediaQuery = !lastWidth || cssStrs.length === 0;
      cssStr += isFirstMediaQuery ? '' : '@media only screen and (min-width: ' + (lastWidth * 2 + width) / 3 + 'px) {';
      var layoutWidth = width - styleParams.imageMargin * 2;
      layout.items.forEach(function (item, i) {
        var id = _cssScrollHelper.cssScrollHelper.getDomId(item);
        if (i < 50) {
          var style = getImageStyle(item);
          var top = 'top:' + Math.round(10000 * (style.top / layoutWidth)) / 100 + 'vw !important;';
          // const left = `left:${Math.round(10000 * (style.left / layoutWidth)) / 100}vw !important;`;
          var _width = 'width:' + Math.round(10000 * (style.width / layoutWidth)) / 100 + 'vw !important;';
          var height = 'height:' + Math.round(10000 * (style.height / layoutWidth)) / 100 + 'vw !important;';
          var leftPercent = 'left:' + Math.round(10000 * (style.left / layoutWidth)) / 100 + '% !important;';
          var widthPercent = 'width:' + Math.round(10000 * (style.width / layoutWidth)) / 100 + '% !important;';
          var transition = 'all 0.4s ease';
          cssStr += '#' + id + ' {' + top + leftPercent + widthPercent + height + transition + '}';
          cssStr += '#' + id + ' .gallery-item-wrapper, #' + id + ' .gallery-item-hover, #' + id + ' .gallery-item {' + _width + height + '}';
        } else {
          cssStr += '#' + id + '{display:none;}';
        }
      });

      cssStr += isFirstMediaQuery ? '' : '}';
      cssStrs.push(cssStr);
    }
  });

  return cssStrs;
};

var createCssLayouts = exports.createCssLayouts = function createCssLayouts(layoutParams, isMobile) {
  var widths = isMobile ? mobileWidths : desktopWidths;
  var cssLayouts = widths.map(function (width) {
    var _layoutParams = (0, _extends3.default)({}, layoutParams, { container: (0, _extends3.default)({}, layoutParams.container, { galleryWidth: width, width: width }) });
    return (0, _proGalleryLayouter.createLayout)(_layoutParams);
  });
  return createCssFromLayouts(cssLayouts, layoutParams.styleParams, widths);
};